module.exports = __webpack_public_path__ + "static/img/no-good-img.581f1339.png";